import React from "react";
import ToolResultCard from "./ToolResultCard";

const MessageItem = ({ message, hideTimestamp }) => {
  const isUser = message.role === "user";

  return (
    <div
      className={`d-flex mb-2 ${isUser ? "justify-content-end" : "justify-content-start"}`}
    >
      <div
        style={{
          maxWidth: "85%",
          minWidth: isUser ? "auto" : "40%",
        }}
      >
        {/* Message bubble */}
        <div
          className={isUser ? "bg-primary text-white" : "bg-light"}
          style={{
            padding: "8px 14px",
            borderRadius: isUser
              ? "10px 10px 4px 10px"
              : "10px 10px 10px 4px",
          }}
        >
          {/* Text content */}
          {message.text && (
            <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {message.text}
            </div>
          )}
        </div>

        {/* Action proposal indicator */}
        {!isUser && message.data?.type === "action_proposal" && (
          <div
            className="mt-1 p-2 rounded d-flex align-items-center"
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              fontSize: 12,
            }}
          >
            <i className="simple-icon-exclamation mr-2 text-warning" />
            <span>Yêu cầu xác nhận — vui lòng xem hộp thoại xác nhận</span>
          </div>
        )}

        {/* Structured content (cards, tables) - only for assistant */}
        {!isUser && message.data && message.data.type !== "text" && (
          <ToolResultCard data={message.data} />
        )}

        {/* Source references (knowledge queries) */}
        {!isUser &&
          message.data?.references &&
          message.data.references.length > 0 && (
            <div
              className="mt-2 p-2"
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #e9ecef",
                borderRadius: 10,
                fontSize: 12,
              }}
            >
              <div
                className="text-muted font-weight-bold mb-1"
                style={{ fontSize: 11 }}
              >
                <i className="simple-icon-docs mr-1" />
                Nguồn tham chiếu:
              </div>
              {message.data.references.map((ref, i) => (
                <div key={i} className="text-muted" style={{ fontSize: 11 }}>
                  <i className="simple-icon-doc mr-1" />
                  {ref.title || ref.filename || "Tài liệu"}
                </div>
              ))}
            </div>
          )}

        {/* Suggested actions */}
        {!isUser &&
          message.data?.suggestedActions &&
          message.data.suggestedActions.length > 0 && (
            <div className="mt-2 d-flex flex-wrap">
              {message.data.suggestedActions.map((action, i) => (
                <button
                  key={i}
                  className="btn btn-outline-secondary btn-xs mr-1 mb-1"
                  style={{ fontSize: 12, padding: "2px 8px", borderRadius: 12 }}
                  onClick={() => {
                    // Find ChatWindow's handleSendMessage via DOM event
                    const event = new CustomEvent("ai-copilot-send", {
                      detail: { text: action },
                      bubbles: true,
                    });
                    document.dispatchEvent(event);
                  }}
                >
                  {action}
                </button>
              ))}
            </div>
          )}

        {/* Timestamp — hidden if same time as adjacent message */}
        {!hideTimestamp && (
          <div
            className={`mt-1 ${isUser ? "text-right" : "text-left"}`}
            style={{ fontSize: 11, color: "#999" }}
          >
            {message.timestamp
              ? new Date(message.timestamp).toLocaleTimeString("vi-VN", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageItem;
